/**
 * API path for one of a bookmark's images, carrying the image's version as
 * `?v=`: the row's `screenshot_version`, `og_image_version` or
 * `favicon_version`. The image caches — the service worker's CacheFirst route,
 * the extension's CacheStorage writer, the in-memory object-URL cache — never
 * revalidate and are keyed by this path, so a replaced image has to arrive
 * under a different URL or every layer keeps serving the old one. Every write
 * of an image moves its version; 0 is a version too (images stored before
 * versions existed), so only a missing one omits the query.
 */
export function bookmarkImagePath(
  bookmarkId: string,
  kind: 'screenshot' | 'og-image' | 'favicon',
  version?: number | null,
): string {
  const path = `/api/bookmarks/${bookmarkId}/${kind}`;
  return version != null ? `${path}?v=${version}` : path;
}

/**
 * URL validation: positive allowlist for http/https with a non-empty host.
 * Rejects mailto:, javascript:, view-source:, file:, data:, chrome://,
 * chrome-extension://, about:, edge://, and any unparsable garbage.
 */
export function isAllowedUrl(url: string): boolean {
  if (!url) return false;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  return (
    (parsed.protocol === 'http:' || parsed.protocol === 'https:') &&
    parsed.hostname.length > 0
  );
}
